export default {
  title: "light",
  colors: {
    white: "rgb(255, 255, 255)",
    primary: "rgb(31, 23, 23)",
    primary2: "rgba(31, 23, 23, 0.75)",
    primary3: "rgb(255, 255, 255)",
    secondary: "rgba(255, 0, 0, 0.9)",
    secondary2: " rgba(255, 0, 0, 0.6)",
    grey1: "rgb(244, 246, 248)",
    grey2: "rgb(201, 201, 201)",
    grey3: "rgb(110, 128, 152)",
    grey4: "rgb(25, 32, 45)",
    grey5: "rgb(31, 23, 23)",
    negative: "rgb(230, 0, 0)",
    warning: "rgb(255, 205, 7)",
    sucess: "rgb(22, 136, 33)",
    information: "rgb(21, 91, 203)",
  },
};
